<template>
    <v-dialog v-model="dialog" width="1000px">
        <v-card>
            <v-card-title>
                Restrictions {{hspl.plan_code }}
                <v-spacer></v-spacer>
                <btn_audit table="hprs" :encrid="hspl.plan_encrid" :size=30 tooltip="audit of restrictions" />
                <v-btn class="primary ma-2" x-small @click="updPlan(hspl.hspl_encrid)">Add Restriction</v-btn>
            </v-card-title>
            <v-form ref="updHspl" v-model="updHsplValid">
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <td><b>Restriction</b></td>
                                <td><b>Stay</b></td>
                                <td><b>Booking</b></td>
                                <td><b>Days before stay</b></td>
                                <td><b>Remark</b></td>
                                <td><b>Created</b></td>
                                <td><b>User</b></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr  v-for="(hprsRecord,i) in hspl.hprs" :key="i">
                                <td>{{hprsRecord.plrstaal_oms}}</td>
                                <td>{{hprsRecord.stay}}</td>
                                <td>{{hprsRecord.booking}}</td>
                                <td>{{hprsRecord.advb}}</td>
                                <td>{{hprsRecord.hprs_opm}}</td>
                                <td>{{hprsRecord.hprs_inv_dt}}</td>
                                <td>{{hprsRecord.gebr_code}}</td>
                                <td><v-btn text icon v-if="hprsRecord.hprs_may_be_removed === 'Yes'" @click="updRmvHprs(hprsRecord.hprs_encrid, true, false)"><v-icon small>mdi-wrench-outline</v-icon></v-btn></td>
                                <td><v-btn text icon v-if="hprsRecord.hprs_may_be_removed === 'Yes'" @click="updRmvHprs(hprsRecord.hprs_encrid, false, true)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
            <updRmvHprs ref="updRmvHprs" @reloadHuis="reloadHuis"/>
            <updPlan ref="updPlan" @reloadHuis="reloadHuis"></updPlan>
        </v-card>
    </v-dialog>
</template>

<script>
    import updRmvHprs from "@/views/huis/hspl/updRmvHprs.vue";
    import updPlan from "@/views/huis/hspl/updPlan.vue";
    import btn_audit from "@/components/ui/buttons/btn_audit.vue";

    export default {
        components: {
            updPlan,
            updRmvHprs,
            btn_audit
        },
        data() {
            return {
                dialog: false,
                hspl_encrid: null,
                huis_encrid: null,
                updHsplValid: false,
                hspl: {}
            }
        },
        methods: {
            open(hspl_encrid) {
                this.hspl_encrid = hspl_encrid;
                this.getHprsOfHspl();
            },
            getHprsOfHspl() {
                this.$axios.post("ares/json/ares/huis/hspl/getHprsOfHspl.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHprsOfHspl"
                    },
                    getHprsOfHspl: {
                        hspl_encrid: this.hspl_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hspl = res.data.getHprsOfHspl;
                        this.huis_encrid = res.data.getHprsOfHspl.huis_encrid;
                        this.dialog = true;
                    }
                });
            },
            updRmvHprs(hprs_encrid, can_edit, can_delete) {
                this.$refs.updRmvHprs.openDialog(hprs_encrid, this.huis_encrid, can_edit, can_delete);
            },
            updPlan(hspl_encrid) {
                this.$refs.updPlan.open('',hspl_encrid);
            },
            reloadHuis() {
                this.$emit("reloadHuis");
                this.getHprsOfHspl();
            }
        }
    }
</script>

